import AvatarsWings_0001_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0001_0001_th.png';
import AvatarsWings_0002_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0002_0001_th.png';
import AvatarsWings_0003_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0003_0001_th.png';
import AvatarsWings_0004_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0004_0001_th.png';
import AvatarsWings_0005_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0005_0001_th.png';
import AvatarsWings_0006_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0006_0001_th.png';
import AvatarsWings_0007_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0007_0001_th.png';
import AvatarsWings_0008_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0008_0001_th.png';
import AvatarsWings_0009_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0009_0001_th.png';
import AvatarsWings_0010_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0010_0001_th.png';
import AvatarsWings_0011_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0011_0001_th.png';
import AvatarsWings_0012_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0012_0001_th.png';
import AvatarsWings_0013_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0013_0001_th.png';
import AvatarsWings_0014_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0014_0001_th.png';
import AvatarsWings_0015_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0015_0001_th.png';
import AvatarsWings_0016_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0016_0001_th.png';
import AvatarsWings_0017_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0017_0001_th.png';
import AvatarsWings_0018_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0018_0001_th.png';
import AvatarsWings_0019_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0019_0001_th.png';
import AvatarsWings_0020_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0020_0001_th.png';
import AvatarsWings_0021_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0021_0001_th.png';
import AvatarsWings_0022_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0022_0001_th.png';
import AvatarsWings_0023_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0023_0001_th.png';
import AvatarsWings_0024_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0024_0001_th.png';
import AvatarsWings_0025_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0025_0001_th.png';
import AvatarsWings_0026_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0026_0001_th.png';
import AvatarsWings_0027_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0027_0001_th.png';
import AvatarsWings_0028_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0028_0001_th.png';
import AvatarsWings_0029_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0029_0001_th.png';
import AvatarsWings_0030_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0030_0001_th.png';
import AvatarsWings_0031_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0031_0001_th.png';
import AvatarsWings_0032_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0032_0001_th.png';
import AvatarsWings_0033_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0033_0001_th.png';
import AvatarsWings_0034_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0034_0001_th.png';
import AvatarsWings_0035_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0035_0001_th.png';
import AvatarsWings_0036_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0036_0001_th.png';
import AvatarsWings_0037_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0037_0001_th.png';
import AvatarsWings_0038_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0038_0001_th.png';
import AvatarsWings_0039_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0039_0001_th.png';
import AvatarsWings_0040_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0040_0001_th.png';
import AvatarsWings_0041_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0041_0001_th.png';
import AvatarsWings_0042_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0042_0001_th.png';
import AvatarsWings_0043_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0043_0001_th.png';
import AvatarsWings_0044_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0044_0001_th.png';
import AvatarsWings_0045_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0045_0001_th.png';
import AvatarsWings_0046_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0046_0001_th.png';
import AvatarsWings_0047_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0047_0001_th.png';
import AvatarsWings_0048_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0048_0001_th.png';
import AvatarsWings_0049_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0049_0001_th.png';
import AvatarsWings_0050_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0050_0001_th.png';
import AvatarsWings_0051_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0051_0001_th.png';
import AvatarsWings_0052_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0052_0001_th.png';
import AvatarsWings_0053_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0053_0001_th.png';
import AvatarsWings_0054_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0054_0001_th.png';
import AvatarsWings_0055_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0055_0001_th.png';
import AvatarsWings_0056_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0056_0001_th.png';
import AvatarsWings_0057_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0057_0001_th.png';
import AvatarsWings_0058_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0058_0001_th.png';
import AvatarsWings_0059_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0059_0001_th.png';
import AvatarsWings_0060_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0060_0001_th.png';
import AvatarsWings_0061_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0061_0001_th.png';
import AvatarsWings_0062_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0062_0001_th.png';
import AvatarsWings_0063_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0063_0001_th.png';
import AvatarsWings_0064_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0064_0001_th.png';
import AvatarsWings_0065_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0065_0001_th.png';
import AvatarsWings_0066_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0066_0001_th.png';
import AvatarsWings_0067_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0067_0001_th.png';
import AvatarsWings_0068_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0068_0001_th.png';
import AvatarsWings_0069_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0069_0001_th.png';
import AvatarsWings_0070_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0070_0001_th.png';
import AvatarsWings_0071_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0071_0001_th.png';
import AvatarsWings_0072_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0072_0001_th.png';
import AvatarsWings_0073_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0073_0001_th.png';
import AvatarsWings_0074_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0074_0001_th.png';
import AvatarsWings_0075_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0075_0001_th.png';
import AvatarsWings_0076_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0076_0001_th.png';
import AvatarsWings_0077_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0077_0001_th.png';
import AvatarsWings_0078_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0078_0001_th.png';
import AvatarsWings_0079_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0079_0001_th.png';
import AvatarsWings_0080_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0080_0001_th.png';
import AvatarsWings_0081_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0081_0001_th.png';
import AvatarsWings_0082_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0082_0001_th.png';
import AvatarsWings_0083_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0083_0001_th.png';
import AvatarsWings_0084_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0084_0001_th.png';
import AvatarsWings_0085_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0085_0001_th.png';
import AvatarsWings_0086_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0086_0001_th.png';
import AvatarsWings_0087_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0087_0001_th.png';
import AvatarsWings_0088_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0088_0001_th.png';
import AvatarsWings_0089_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0089_0001_th.png';
import AvatarsWings_0090_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0090_0001_th.png';
import AvatarsWings_0091_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0091_0001_th.png';
import AvatarsWings_0092_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0092_0001_th.png';
import AvatarsWings_0093_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0093_0001_th.png';
import AvatarsWings_0094_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0094_0001_th.png';
import AvatarsWings_0095_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0095_0001_th.png';
import AvatarsWings_0096_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0096_0001_th.png';
import AvatarsWings_0097_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0097_0001_th.png';
import AvatarsWings_0098_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0098_0001_th.png';
import AvatarsWings_0099_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0099_0001_th.png';
import AvatarsWings_0100_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0100_0001_th.png';
import AvatarsWings_0101_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0101_0001_th.png';
import AvatarsWings_0102_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0102_0001_th.png';
import AvatarsWings_0103_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0103_0001_th.png';
import AvatarsWings_0104_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0104_0001_th.png';
import AvatarsWings_0105_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0105_0001_th.png';
import AvatarsWings_0106_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0106_0001_th.png';
import AvatarsWings_0107_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0107_0001_th.png';
import AvatarsWings_0108_0001_th from '../../assets/graphics/png/collections/avatar/_thumbnails/wings/avatars-wings-0108_0001_th.png';
import AvatarsWings_0001_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0001_0001.png';
import AvatarsWings_0002_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0002_0001.png';
import AvatarsWings_0003_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0003_0001.png';
import AvatarsWings_0004_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0004_0001.png';
import AvatarsWings_0005_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0005_0001.png';
import AvatarsWings_0006_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0006_0001.png';
import AvatarsWings_0007_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0007_0001.png';
import AvatarsWings_0008_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0008_0001.png';
import AvatarsWings_0009_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0009_0001.png';
import AvatarsWings_0010_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0010_0001.png';
import AvatarsWings_0011_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0011_0001.png';
import AvatarsWings_0012_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0012_0001.png';
import AvatarsWings_0013_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0013_0001.png';
import AvatarsWings_0014_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0014_0001.png';
import AvatarsWings_0015_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0015_0001.png';
import AvatarsWings_0016_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0016_0001.png';
import AvatarsWings_0017_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0017_0001.png';
import AvatarsWings_0018_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0018_0001.png';
import AvatarsWings_0019_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0019_0001.png';
import AvatarsWings_0020_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0020_0001.png';
import AvatarsWings_0021_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0021_0001.png';
import AvatarsWings_0022_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0022_0001.png';
import AvatarsWings_0023_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0023_0001.png';
import AvatarsWings_0024_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0024_0001.png';
import AvatarsWings_0025_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0025_0001.png';
import AvatarsWings_0026_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0026_0001.png';
import AvatarsWings_0027_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0027_0001.png';
import AvatarsWings_0028_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0028_0001.png';
import AvatarsWings_0029_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0029_0001.png';
import AvatarsWings_0030_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0030_0001.png';
import AvatarsWings_0031_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0031_0001.png';
import AvatarsWings_0032_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0032_0001.png';
import AvatarsWings_0033_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0033_0001.png';
import AvatarsWings_0034_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0034_0001.png';
import AvatarsWings_0035_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0035_0001.png';
import AvatarsWings_0036_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0036_0001.png';
import AvatarsWings_0037_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0037_0001.png';
import AvatarsWings_0038_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0038_0001.png';
import AvatarsWings_0039_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0039_0001.png';
import AvatarsWings_0040_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0040_0001.png';
import AvatarsWings_0041_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0041_0001.png';
import AvatarsWings_0042_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0042_0001.png';
import AvatarsWings_0043_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0043_0001.png';
import AvatarsWings_0044_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0044_0001.png';
import AvatarsWings_0045_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0045_0001.png';
import AvatarsWings_0046_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0046_0001.png';
import AvatarsWings_0047_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0047_0001.png';
import AvatarsWings_0048_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0048_0001.png';
import AvatarsWings_0049_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0049_0001.png';
import AvatarsWings_0050_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0050_0001.png';
import AvatarsWings_0051_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0051_0001.png';
import AvatarsWings_0052_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0052_0001.png';
import AvatarsWings_0053_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0053_0001.png';
import AvatarsWings_0054_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0054_0001.png';
import AvatarsWings_0055_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0055_0001.png';
import AvatarsWings_0056_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0056_0001.png';
import AvatarsWings_0057_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0057_0001.png';
import AvatarsWings_0058_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0058_0001.png';
import AvatarsWings_0059_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0059_0001.png';
import AvatarsWings_0060_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0060_0001.png';
import AvatarsWings_0061_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0061_0001.png';
import AvatarsWings_0062_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0062_0001.png';
import AvatarsWings_0063_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0063_0001.png';
import AvatarsWings_0064_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0064_0001.png';
import AvatarsWings_0065_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0065_0001.png';
import AvatarsWings_0066_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0066_0001.png';
import AvatarsWings_0067_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0067_0001.png';
import AvatarsWings_0068_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0068_0001.png';
import AvatarsWings_0069_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0069_0001.png';
import AvatarsWings_0070_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0070_0001.png';
import AvatarsWings_0071_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0071_0001.png';
import AvatarsWings_0072_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0072_0001.png';
import AvatarsWings_0073_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0073_0001.png';
import AvatarsWings_0074_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0074_0001.png';
import AvatarsWings_0075_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0075_0001.png';
import AvatarsWings_0076_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0076_0001.png';
import AvatarsWings_0077_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0077_0001.png';
import AvatarsWings_0078_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0078_0001.png';
import AvatarsWings_0079_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0079_0001.png';
import AvatarsWings_0080_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0080_0001.png';
import AvatarsWings_0081_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0081_0001.png';
import AvatarsWings_0082_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0082_0001.png';
import AvatarsWings_0083_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0083_0001.png';
import AvatarsWings_0084_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0084_0001.png';
import AvatarsWings_0085_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0085_0001.png';
import AvatarsWings_0086_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0086_0001.png';
import AvatarsWings_0087_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0087_0001.png';
import AvatarsWings_0088_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0088_0001.png';
import AvatarsWings_0089_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0089_0001.png';
import AvatarsWings_0090_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0090_0001.png';
import AvatarsWings_0091_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0091_0001.png';
import AvatarsWings_0092_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0092_0001.png';
import AvatarsWings_0093_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0093_0001.png';
import AvatarsWings_0094_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0094_0001.png';
import AvatarsWings_0095_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0095_0001.png';
import AvatarsWings_0096_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0096_0001.png';
import AvatarsWings_0097_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0097_0001.png';
import AvatarsWings_0098_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0098_0001.png';
import AvatarsWings_0099_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0099_0001.png';
import AvatarsWings_0100_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0100_0001.png';
import AvatarsWings_0101_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0101_0001.png';
import AvatarsWings_0102_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0102_0001.png';
import AvatarsWings_0103_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0103_0001.png';
import AvatarsWings_0104_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0104_0001.png';
import AvatarsWings_0105_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0105_0001.png';
import AvatarsWings_0106_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0106_0001.png';
import AvatarsWings_0107_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0107_0001.png';
import AvatarsWings_0108_0001 from '../../assets/graphics/png/collections/avatar/wings/avatars-wings-0108_0001.png';

import {
  AvatarCategory,
  AvatarConstant,
  AvatarItem,
  AvatarSet,
  AvatarType,
} from './utils';

export enum AvatarWingsItemNo {
  a1 = 'avatars-wings-00000001',
  a2 = 'avatars-wings-00000002',
  a3 = 'avatars-wings-00000003',
  a4 = 'avatars-wings-00000004',
  a5 = 'avatars-wings-00000005',
  a6 = 'avatars-wings-00000006',
  a7 = 'avatars-wings-00000007',
  a8 = 'avatars-wings-00000008',
  a9 = 'avatars-wings-00000009',
  a10 = 'avatars-wings-00000010',
  a11 = 'avatars-wings-00000011',
  a12 = 'avatars-wings-00000012',
  a13 = 'avatars-wings-00000013',
  a14 = 'avatars-wings-00000014',
  a15 = 'avatars-wings-00000015',
  a16 = 'avatars-wings-00000016',
  a17 = 'avatars-wings-00000017',
  a18 = 'avatars-wings-00000018',
  a19 = 'avatars-wings-00000019',
  a20 = 'avatars-wings-00000020',
  a21 = 'avatars-wings-00000021',
  a22 = 'avatars-wings-00000022',
  a23 = 'avatars-wings-00000023',
  a24 = 'avatars-wings-00000024',
  a25 = 'avatars-wings-00000025',
  a26 = 'avatars-wings-00000026',
  a27 = 'avatars-wings-00000027',
  a28 = 'avatars-wings-00000028',
  a29 = 'avatars-wings-00000029',
  a30 = 'avatars-wings-00000030',
  a31 = 'avatars-wings-00000031',
  a32 = 'avatars-wings-00000032',
  a33 = 'avatars-wings-00000033',
  a34 = 'avatars-wings-00000034',
  a35 = 'avatars-wings-00000035',
  a36 = 'avatars-wings-00000036',
  a37 = 'avatars-wings-00000037',
  a38 = 'avatars-wings-00000038',
  a39 = 'avatars-wings-00000039',
  a40 = 'avatars-wings-00000040',
  a41 = 'avatars-wings-00000041',
  a42 = 'avatars-wings-00000042',
  a43 = 'avatars-wings-00000043',
  a44 = 'avatars-wings-00000044',
  a45 = 'avatars-wings-00000045',
  a46 = 'avatars-wings-00000046',
  a47 = 'avatars-wings-00000047',
  a48 = 'avatars-wings-00000048',
  a49 = 'avatars-wings-00000049',
  a50 = 'avatars-wings-00000050',
  a51 = 'avatars-wings-00000051',
  a52 = 'avatars-wings-00000052',
  a53 = 'avatars-wings-00000053',
  a54 = 'avatars-wings-00000054',
  a55 = 'avatars-wings-00000055',
  a56 = 'avatars-wings-00000056',
  a57 = 'avatars-wings-00000057',
  a58 = 'avatars-wings-00000058',
  a59 = 'avatars-wings-00000059',
  a60 = 'avatars-wings-00000060',
  a61 = 'avatars-wings-00000061',
  a62 = 'avatars-wings-00000062',
  a63 = 'avatars-wings-00000063',
  a64 = 'avatars-wings-00000064',
  a65 = 'avatars-wings-00000065',
  a66 = 'avatars-wings-00000066',
  a67 = 'avatars-wings-00000067',
  a68 = 'avatars-wings-00000068',
  a69 = 'avatars-wings-00000069',
  a70 = 'avatars-wings-00000070',
  a71 = 'avatars-wings-00000071',
  a72 = 'avatars-wings-00000072',
  a73 = 'avatars-wings-00000073',
  a74 = 'avatars-wings-00000074',
  a75 = 'avatars-wings-00000075',
  a76 = 'avatars-wings-00000076',
  a77 = 'avatars-wings-00000077',
  a78 = 'avatars-wings-00000078',
  a79 = 'avatars-wings-00000079',
  a80 = 'avatars-wings-00000080',
  a81 = 'avatars-wings-00000081',
  a82 = 'avatars-wings-00000082',
  a83 = 'avatars-wings-00000083',
  a84 = 'avatars-wings-00000084',
  a85 = 'avatars-wings-00000085',
  a86 = 'avatars-wings-00000086',
  a87 = 'avatars-wings-00000087',
  a88 = 'avatars-wings-00000088',
  a89 = 'avatars-wings-00000089',
  a90 = 'avatars-wings-00000090',
  a91 = 'avatars-wings-00000091',
  a92 = 'avatars-wings-00000092',
  a93 = 'avatars-wings-00000093',
  a94 = 'avatars-wings-00000094',
  a95 = 'avatars-wings-00000095',
  a96 = 'avatars-wings-00000096',
  a97 = 'avatars-wings-00000097',
  a98 = 'avatars-wings-00000098',
  a99 = 'avatars-wings-00000099',
  a100 = 'avatars-wings-00000100',
  a101 = 'avatars-wings-00000101',
  a102 = 'avatars-wings-00000102',
  a103 = 'avatars-wings-00000103',
  a104 = 'avatars-wings-00000104',
  a105 = 'avatars-wings-00000105',
  a106 = 'avatars-wings-00000106',
  a107 = 'avatars-wings-00000107',
  a108 = 'avatars-wings-00000108',
}

export const AVATAR_WINGS = Object.freeze<AvatarItem<AvatarCategory.Wings>[]>([
  {
    itemId: AvatarWingsItemNo.a1,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 1,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0001_0001,
      thumbnailPrefix: AvatarsWings_0001_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -55,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a2,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 2,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0002_0001,
      thumbnailPrefix: AvatarsWings_0002_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -46,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a3,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 3,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0003_0001,
      thumbnailPrefix: AvatarsWings_0003_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -41,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a4,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 4,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0004_0001,
      thumbnailPrefix: AvatarsWings_0004_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -44,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a5,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 5,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0005_0001,
      thumbnailPrefix: AvatarsWings_0005_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -38,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a6,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 6,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0006_0001,
      thumbnailPrefix: AvatarsWings_0006_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -38,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a7,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 7,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0007_0001,
      thumbnailPrefix: AvatarsWings_0007_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -49,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a8,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 8,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0008_0001,
      thumbnailPrefix: AvatarsWings_0008_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -51,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a9,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 9,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0009_0001,
      thumbnailPrefix: AvatarsWings_0009_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -44,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a10,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 10,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0010_0001,
      thumbnailPrefix: AvatarsWings_0010_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -44,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a11,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 11,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0011_0001,
      thumbnailPrefix: AvatarsWings_0011_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -40,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a12,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 12,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0012_0001,
      thumbnailPrefix: AvatarsWings_0012_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -44,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a13,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 13,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0013_0001,
      thumbnailPrefix: AvatarsWings_0013_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -48,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a14,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 14,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0014_0001,
      thumbnailPrefix: AvatarsWings_0014_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -44,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a15,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 15,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0015_0001,
      thumbnailPrefix: AvatarsWings_0015_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -41,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a16,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 16,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0016_0001,
      thumbnailPrefix: AvatarsWings_0016_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -50,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a17,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 17,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0017_0001,
      thumbnailPrefix: AvatarsWings_0017_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -47,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a18,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 18,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0018_0001,
      thumbnailPrefix: AvatarsWings_0018_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -47,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a19,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 19,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0019_0001,
      thumbnailPrefix: AvatarsWings_0019_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -41,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a20,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 20,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0020_0001,
      thumbnailPrefix: AvatarsWings_0020_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -51,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a21,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 21,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0021_0001,
      thumbnailPrefix: AvatarsWings_0021_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -50,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a22,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 22,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0022_0001,
      thumbnailPrefix: AvatarsWings_0022_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -44,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a23,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 23,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0023_0001,
      thumbnailPrefix: AvatarsWings_0023_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -49,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a24,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 24,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0024_0001,
      thumbnailPrefix: AvatarsWings_0024_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -53,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a25,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 25,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0025_0001,
      thumbnailPrefix: AvatarsWings_0025_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -48,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a26,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 26,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0026_0001,
      thumbnailPrefix: AvatarsWings_0026_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -38,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a27,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 27,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0027_0001,
      thumbnailPrefix: AvatarsWings_0027_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -46,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a28,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 28,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0028_0001,
      thumbnailPrefix: AvatarsWings_0028_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -25,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a29,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 29,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0029_0001,
      thumbnailPrefix: AvatarsWings_0029_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -51,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a30,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 30,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0030_0001,
      thumbnailPrefix: AvatarsWings_0030_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -41,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a31,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 31,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0031_0001,
      thumbnailPrefix: AvatarsWings_0031_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -46,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a32,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 32,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0032_0001,
      thumbnailPrefix: AvatarsWings_0032_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -46,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a33,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 33,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0033_0001,
      thumbnailPrefix: AvatarsWings_0033_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -50,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a34,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 34,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0034_0001,
      thumbnailPrefix: AvatarsWings_0034_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -31,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a35,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 35,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0035_0001,
      thumbnailPrefix: AvatarsWings_0035_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -32,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a36,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 36,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0036_0001,
      thumbnailPrefix: AvatarsWings_0036_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -28,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a37,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 37,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0037_0001,
      thumbnailPrefix: AvatarsWings_0037_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -32,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a38,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 38,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0038_0001,
      thumbnailPrefix: AvatarsWings_0038_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -39,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a39,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 39,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0039_0001,
      thumbnailPrefix: AvatarsWings_0039_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -39,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a40,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 40,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0040_0001,
      thumbnailPrefix: AvatarsWings_0040_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -44,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a41,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 41,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0041_0001,
      thumbnailPrefix: AvatarsWings_0041_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -48,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a42,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 42,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0042_0001,
      thumbnailPrefix: AvatarsWings_0042_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -24,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a43,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 43,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0043_0001,
      thumbnailPrefix: AvatarsWings_0043_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -45,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a44,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 44,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0044_0001,
      thumbnailPrefix: AvatarsWings_0044_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -45,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a45,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 45,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0045_0001,
      thumbnailPrefix: AvatarsWings_0045_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -45,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a46,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 46,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0046_0001,
      thumbnailPrefix: AvatarsWings_0046_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -33,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a47,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 47,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0047_0001,
      thumbnailPrefix: AvatarsWings_0047_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -47,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a48,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 48,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0048_0001,
      thumbnailPrefix: AvatarsWings_0048_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    position: {
      y: -48,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a49,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 49,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0049_0001,
      thumbnailPrefix: AvatarsWings_0049_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a50,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 50,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0050_0001,
      thumbnailPrefix: AvatarsWings_0050_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a51,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 51,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0051_0001,
      thumbnailPrefix: AvatarsWings_0051_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a52,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 52,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0052_0001,
      thumbnailPrefix: AvatarsWings_0052_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a53,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 53,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0053_0001,
      thumbnailPrefix: AvatarsWings_0053_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a54,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 54,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0054_0001,
      thumbnailPrefix: AvatarsWings_0054_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a55,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 55,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0055_0001,
      thumbnailPrefix: AvatarsWings_0055_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a56,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 56,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0056_0001,
      thumbnailPrefix: AvatarsWings_0056_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a57,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 57,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0057_0001,
      thumbnailPrefix: AvatarsWings_0057_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a58,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 58,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0058_0001,
      thumbnailPrefix: AvatarsWings_0058_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a59,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 59,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0059_0001,
      thumbnailPrefix: AvatarsWings_0059_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a60,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 60,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0060_0001,
      thumbnailPrefix: AvatarsWings_0060_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a61,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 61,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0061_0001,
      thumbnailPrefix: AvatarsWings_0061_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a62,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 62,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0062_0001,
      thumbnailPrefix: AvatarsWings_0062_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a63,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 63,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0063_0001,
      thumbnailPrefix: AvatarsWings_0063_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a64,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 64,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0064_0001,
      thumbnailPrefix: AvatarsWings_0064_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a65,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 65,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0065_0001,
      thumbnailPrefix: AvatarsWings_0065_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a66,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 66,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0066_0001,
      thumbnailPrefix: AvatarsWings_0066_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a67,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 67,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0067_0001,
      thumbnailPrefix: AvatarsWings_0067_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a68,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 68,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0068_0001,
      thumbnailPrefix: AvatarsWings_0068_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a69,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 69,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0069_0001,
      thumbnailPrefix: AvatarsWings_0069_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a70,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 70,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0070_0001,
      thumbnailPrefix: AvatarsWings_0070_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a71,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 71,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0071_0001,
      thumbnailPrefix: AvatarsWings_0071_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a72,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 72,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0072_0001,
      thumbnailPrefix: AvatarsWings_0072_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a73,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 73,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0073_0001,
      thumbnailPrefix: AvatarsWings_0073_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a74,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 74,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0074_0001,
      thumbnailPrefix: AvatarsWings_0074_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a75,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 75,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0075_0001,
      thumbnailPrefix: AvatarsWings_0075_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a76,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 76,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0076_0001,
      thumbnailPrefix: AvatarsWings_0076_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a77,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 77,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0077_0001,
      thumbnailPrefix: AvatarsWings_0077_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a78,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 78,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0078_0001,
      thumbnailPrefix: AvatarsWings_0078_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a79,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 79,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0079_0001,
      thumbnailPrefix: AvatarsWings_0079_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a80,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 80,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0080_0001,
      thumbnailPrefix: AvatarsWings_0080_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a81,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 81,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0081_0001,
      thumbnailPrefix: AvatarsWings_0081_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a82,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 82,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0082_0001,
      thumbnailPrefix: AvatarsWings_0082_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a83,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 83,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0083_0001,
      thumbnailPrefix: AvatarsWings_0083_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a84,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 84,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0084_0001,
      thumbnailPrefix: AvatarsWings_0084_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a85,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 85,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0085_0001,
      thumbnailPrefix: AvatarsWings_0085_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a86,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 86,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0086_0001,
      thumbnailPrefix: AvatarsWings_0086_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a87,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 87,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0087_0001,
      thumbnailPrefix: AvatarsWings_0087_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a88,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 88,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0088_0001,
      thumbnailPrefix: AvatarsWings_0088_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a89,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 89,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0089_0001,
      thumbnailPrefix: AvatarsWings_0089_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a90,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 90,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0090_0001,
      thumbnailPrefix: AvatarsWings_0090_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a91,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 91,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0091_0001,
      thumbnailPrefix: AvatarsWings_0091_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a92,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 92,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0092_0001,
      thumbnailPrefix: AvatarsWings_0092_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a93,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 93,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0093_0001,
      thumbnailPrefix: AvatarsWings_0093_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a94,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 94,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0094_0001,
      thumbnailPrefix: AvatarsWings_0094_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a95,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 95,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0095_0001,
      thumbnailPrefix: AvatarsWings_0095_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a96,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 96,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0096_0001,
      thumbnailPrefix: AvatarsWings_0096_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a97,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 97,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0097_0001,
      thumbnailPrefix: AvatarsWings_0097_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a98,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 98,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0098_0001,
      thumbnailPrefix: AvatarsWings_0098_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a99,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 99,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0099_0001,
      thumbnailPrefix: AvatarsWings_0099_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a100,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 100,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0100_0001,
      thumbnailPrefix: AvatarsWings_0100_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a101,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 101,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0101_0001,
      thumbnailPrefix: AvatarsWings_0101_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a102,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 102,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0102_0001,
      thumbnailPrefix: AvatarsWings_0102_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a103,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 103,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0103_0001,
      thumbnailPrefix: AvatarsWings_0103_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a104,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 104,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0104_0001,
      thumbnailPrefix: AvatarsWings_0104_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a105,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 105,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0105_0001,
      thumbnailPrefix: AvatarsWings_0105_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a106,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 106,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0106_0001,
      thumbnailPrefix: AvatarsWings_0106_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a107,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Regular,
    index: 107,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0107_0001,
      thumbnailPrefix: AvatarsWings_0107_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
  {
    itemId: AvatarWingsItemNo.a108,
    category: AvatarConstant.Avatars,
    subcategory: AvatarCategory.Wings,
    type: AvatarType.AvatarWings,
    set: AvatarSet.Limited,
    index: 108,
    isVisible: true,
    visual: {
      filePrefix: AvatarsWings_0108_0001,
      thumbnailPrefix: AvatarsWings_0108_0001_th,
      frameCount: 1,
      hasThumbnail: true,
      hasMask: false,
    },
    price: {
      ace: 10,
    },
  },
]);
